module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BrandForm', {
    attrs: {
      "parent-loading": _vm.loading,
      "type": _vm.FORM_TYPE.create,
      "brand": _vm.brand
    },
    on: {
      "cancel": _vm.close,
      "save": _vm.save
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38a68e49","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/brand/CreateBrand.vue
// module id = 3123
// module chunks = 0